
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 20h20a2 2 0 110 4H2a2 2 0 110-4zM17.75 7.002L14 3.252l-9.85 9.85a.491.491 0 00-.15.36v3.04a.5.5 0 00.5.5h3.04a.47.47 0 00.35-.15l9.86-9.85zm2.96-2.96a1 1 0 000-1.41L18.37.292a1 1 0 00-1.41 0L15 2.252l3.75 3.75 1.96-1.96z"}})])
          )
        }
      }
    